const PersonaHook = {
  mounted() {
    const client = new Persona.Client({
      templateId: this.el.dataset.inquiryTemplateId,
      environment: this.el.dataset.environment,
      referenceId: this.el.dataset.referenceId,
      onReady: () => client.open(),
      onEvent: (name, meta) => {
        this.pushEventTo(this.el.getAttribute("phx-target"), name, meta);
      },
      onComplete: ({ inquiryId, status, fields }) => {
        // Inquiry completed. Optionally tell your server about it.
        this.pushEventTo(
          this.el.getAttribute("phx-target"),
          "inquiry-complete",
          { inquiry_id: inquiryId, status: status, fields: fields },
        );
      },
    });
  },
};

export default PersonaHook;
